const LOW_SPEC_CACHE_KEY = "moo_low_spec_mode";

const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const detectLowSpecDevice = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  try {
    const forcedFlag = window.localStorage?.getItem(LOW_SPEC_CACHE_KEY);
    if (forcedFlag === "1") return true;
    if (forcedFlag === "0") return false;
  } catch (_error) {
    // ignore storage access issues
  }

  const cpuCount = toFiniteNumber(navigator.hardwareConcurrency);
  const memoryGb = toFiniteNumber(navigator.deviceMemory);
  const weakCpu = cpuCount > 0 && cpuCount <= 4;
  const weakMemory = memoryGb > 0 && memoryGb <= 4;

  return weakCpu || weakMemory;
};

export const getUiPerfProfile = () => {
  const lowSpec = detectLowSpecDevice();
  return {
    lowSpec,
    headerClockTickMs: lowSpec ? 15000 : 1000,
    onlineOrdersPollIntervalMs: lowSpec ? 30000 : 12000,
    tableDeepVerifyMaxBatch: lowSpec ? 1 : 6,
    loadTablesCooldownMs: lowSpec ? 1800 : 450,
    kdsPollIntervalMs: lowSpec ? 60000 : 30000,
    kdsReloadDebounceMs: lowSpec ? 900 : 180,
    unpaidSnapshotTtlMs: lowSpec ? 20000 : 8000,
  };
};
